import { Routes } from '@angular/router';
import { UiToolkitPageComponent } from './components/ui-toolkit-page/ui-toolkit-page.component';

export const routes: Routes = [
  {
    path: '',
    component: UiToolkitPageComponent
  }
];
